import {CompanyModel} from '../../../models/api/companyModel';
import {AppAction} from '../../appActions';
import {CompanyActionsEnum} from './companyActions';

export function companyReducer(state: CompanyModel, action: AppAction): CompanyModel {
  switch (action.type) {
    // Single company update.
    case CompanyActionsEnum.COMPANY_UPDATED:
      return action.payload;

    default:
      return state;
  }
}
